import type { ReactNode } from "react";

export interface ChipProps {
  children: ReactNode;
  /** `filled`: fondo de categoría. `outline`: contorno rosa, sin fondo. */
  variant: "filled" | "outline";
  /** Solo `filled`. Nombre de variable CSS ("--ds-card-rose") o cualquier color CSS ("var(--ds-card-mist)", "#a1b2c3"). Por defecto, mist. */
  color?: string;
  /** `md` para el detalle de un movimiento; `sm` para las filas de la tabla. */
  size?: "md" | "sm";
}

/** Etiqueta de categoría o etiqueta de movimiento. */
export function Chip({ children, variant, color, size = "md" }: ChipProps) {
  if (variant === "outline") {
    return (
      <span
        className={
          size === "md"
            ? "inline-flex h-7 items-center rounded-full px-3 text-[13px] font-medium leading-none text-[var(--app-text)] shadow-[inset_0_0_0_1.5px_var(--ds-card-rose)]"
            : "inline-flex h-[22px] max-w-full items-center truncate rounded-full px-2 text-xs font-medium leading-none text-[var(--ds-ink)] shadow-[inset_0_0_0_1.5px_var(--ds-card-rose)]"
        }
      >
        {children}
      </span>
    );
  }
  const background = color === undefined ? "var(--ds-card-mist)" : color.startsWith("--") ? `var(${color})` : color;
  return (
    <span
      className={
        size === "md"
          ? "inline-flex h-7 items-center rounded-full px-3 text-[13px] font-medium leading-none text-[var(--ds-on-card)]"
          : "inline-flex h-[22px] max-w-full items-center truncate rounded-full px-2 text-xs font-medium leading-none text-[var(--ds-on-card)]"
      }
      style={{ background }}
    >
      {children}
    </span>
  );
}
